import { render, staticRenderFns } from "./addNew.vue?vue&type=template&id=9337cd70&scoped=true&lang=true&"
import script from "./addNew.vue?vue&type=script&lang=js&"
export * from "./addNew.vue?vue&type=script&lang=js&"
import style0 from "./addNew.vue?vue&type=style&index=0&id=9337cd70&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9337cd70",
  null
  
)

export default component.exports